// frontend/src/slices/cartSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { updateCart } from '../utils/cartUtils';

// const initialState = localStorage.getItem('cart')
//   ? JSON.parse(localStorage.getItem('cart'))
//   : { cartItems: [], shippingAddress: {} };


const initialState = localStorage.getItem('cart')
  ? JSON.parse(localStorage.getItem('cart'))
  : { 
      cartItems: [], 
      shippingAddress: {},
      orderId: null,
      clientSecret: null,
      paymentStatus: null
    };



const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      // On ne garde que ce qui sert dans le panier
      const { user, rating, numReviews, reviews, ...item } = action.payload;

      const existItem = state.cartItems.find((x) => x._id === item._id);

      if (existItem) {
        state.cartItems = state.cartItems.map((x) =>
          x._id === existItem._id ? item : x
        );
      } else {
        state.cartItems = [...state.cartItems, item];
      }

      return updateCart(state, item);
    },

    removeFromCart: (state, action) => {
      state.cartItems = state.cartItems.filter((x) => x._id !== action.payload);
      return updateCart(state);
    },

    saveShippingAddress: (state, action) => {
      state.shippingAddress = action.payload;
      localStorage.setItem('cart', JSON.stringify(state));
    },

    clearCartItems: (state) => {
      state.cartItems = [];
      localStorage.setItem('cart', JSON.stringify(state));
    },

    setOrderId: (state, action) => {
      state.orderId = action.payload;
      localStorage.setItem('cart', JSON.stringify(state));
    },
    setClientSecret: (state, action) => {
      state.clientSecret = action.payload;
      localStorage.setItem('cart', JSON.stringify(state));
    },
    setPaymentStatus: (state, action) => {
      state.paymentStatus = action.payload;
      localStorage.setItem('cart', JSON.stringify(state));
    },


    // reset pour déconnexion utilisateur
    resetCart: (state) => (state = initialState),
  },
});

export const {
  addToCart,
  removeFromCart,
  saveShippingAddress,
  clearCartItems,
  resetCart,
  setOrderId,
  setClientSecret,
  setPaymentStatus,
} = cartSlice.actions;

export default cartSlice.reducer;
